// extracted by mini-css-extract-plugin
module.exports = {"medium":"only screen and (min-width: 768px)","cardWrapper":"_1YQJK _3rXvv _2dO1W _3gDJ4 _3krpm _1PQHc _2cc-R","hideOnTabletPortraitAndUp":"_1bX1F"};